
    import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250617-8efbb0d9/ui-products/asha/components/modal/js/modal';

import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250617-8efbb0d9/ui-products/asha/node_modules/ui-core/components/accordion/js/accordion';

import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250617-8efbb0d9/ui-products/asha/node_modules/ui-core/components/drop-block/js/drop-block';

import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250617-8efbb0d9/ui-products/asha/node_modules/ui-core/components/back-to-top/js/back-to-top';

import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250617-8efbb0d9/ui-products/asha/node_modules/ui-theme/components/sections-navbar/js/sections-navbar';

import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250617-8efbb0d9/ui-products/asha/node_modules/ui-core/components/alert-popup/js/alert-popup';

import QuickSearch from '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250617-8efbb0d9/ui-products/asha/widgets/quick-search/js/quick-search';
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250617-8efbb0d9/ui-products/asha/node_modules/ui-theme/widgets/raa/js/raa';

import mobileMenuMain from './groups/_mobile-menu';
import stickyMain from './groups/_sticky';
const main = (UX) => {
    const $modal = Array.prototype.slice.call(document.getElementsByClassName('modal')),
        $accordion = Array.prototype.slice.call(document.getElementsByClassName('accordion')),
        $dropBlock = Array.prototype.slice.call(document.querySelectorAll('[data-db-target-for]')),
        $backToTop = Array.prototype.slice.call(document.getElementsByClassName('back-to-top')),
        $sidebarSections = Array.prototype.slice.call(document.getElementsByClassName('sections-block')),
        $alertPopup = Array.prototype.slice.call(document.getElementsByClassName('ux-alert-container')),
        $quickSearch = Array.prototype.slice.call(document.getElementsByClassName('quick-search'))

try {
        if ($modal.length ) {
            UX.modal.init($modal);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($accordion.length ) {
            UX.accordion.init($accordion);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($dropBlock.length ) {
            UX.dropBlock.init($dropBlock);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($backToTop.length ) {
            UX.backToTop.init($backToTop);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($sidebarSections.length ) {
            UX.sidebarSections.init($sidebarSections);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($alertPopup.length ) {
            UX.alertPopup.init($alertPopup);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($quickSearch.length ) {
            UX.quickSearch = $quickSearch
                .map(item=>new QuickSearch(item).initialize())
        }
    } catch (err) {
        console.error(err);
    }
    
mobileMenuMain(UX);

stickyMain(UX);

}

    export default main;
        